"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageDealtEventArgs = void 0;
const EventType_1 = require("../EventType");
class DamageDealtEventArgs {
    constructor(targetId, damage, fromCrit, fromDoT) {
        this.targetId = targetId;
        this.damage = damage;
        this.fromCrit = fromCrit;
        this.fromDoT = fromDoT;
        this.__type = EventType_1.EventType.DamageDealt;
        this.__typeName = "DamageDealt";
    }
}
exports.DamageDealtEventArgs = DamageDealtEventArgs;
